var storeSlidePosition = 0;
var etcStoreSlider = document.getElementById('etcStoreReviewCont');
var etcOverflowExpand = document.getElementById('etcExpandReviews');
var etcStoreReviewContainer = document.getElementById('etcStoreReviews');
var expandedContainer = false;


var etcStoreKey = stores[storeKey].email;
var reviewCont = "";
var countRev = 0;
var reviewT = setTimeout(function(){loadTheReviews();}, 300);
var storeT;

function loadTheReviews(){
  for (var x = 0; x < globalStoreReviews.length; x++){
    if (globalStoreReviews[x].email == etcStoreKey){
      if (countRev == 0){
        countRev++;
        reviewCont = '<p class="baseTesti">'+globalStoreReviews[x].review+'<br><b>'+globalStoreReviews[x].name+'</b></p>';
      }else{
        countRev++;
        reviewCont = reviewCont + '<p>'+globalStoreReviews[x].review+'<br><b>'+globalStoreReviews[x].name+'</b></p>';
      }

    }
  }
  if (countRev == 0){
    etcStoreReviewContainer.style.display = "none";
    document.getElementById('reviewsHeading').style.display = "none";
  }else if(countRev == 1){
    etcStoreSlider.innerHTML = reviewCont;
    document.getElementById('storeTestiPrev').style.display = "none";
    document.getElementById('storeTestiNext').style.display = "none";
    document.getElementById('reviewsHeading').innerHTML = "A Review For This Store";

  }else{
    etcStoreSlider.innerHTML = reviewCont;
    document.getElementById('reviewsHeading').innerHTML = "Reviews For This Store";
  }


  if (countRev > 0){
    for (var xs = 0;xs < etcStoreSlider.getElementsByTagName('p').length;xs++){
      if ((etcStoreSlider.getElementsByTagName('p')[xs].scrollHeight - etcStoreSlider.getElementsByTagName('p')[xs].clientHeight) > 20){
        etcStoreSlider.getElementsByTagName('p')[xs].classList.add('overflowReview');
      }
    }

    storeT = setTimeout(function(){slideStoreOut();}, 7000);

    if (etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].classList.contains('overflowReview')){
      etcOverflowExpand.style.display = "block";
    }else{
      etcOverflowExpand.style.display = "none";
    }
  }
}



function expandContainer(){
  if (!expandedContainer){
    etcStoreReviewContainer.classList.add('etcContainerExpanded');
    expandedContainer = true;
    clearTimeout(storeT);
    etcOverflowExpand.innerHTML = "Read Less";
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("justify-content","center","important");
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("height","100%","important");
  }else{
    etcStoreReviewContainer.classList.remove('etcContainerExpanded');
    expandedContainer = false;
    etcOverflowExpand.innerHTML = "Read More";
    storeT = setTimeout(function(){slideStoreOut();}, 6000);
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("justify-content","start","important");
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("height","90%","important");
  }
}

function slideStoreOut(){
  clearTimeout(storeT);
  if (expandedContainer) {
    etcStoreReviewContainer.classList.remove('etcContainerExpanded');
    expandedContainer = false;
    etcOverflowExpand.innerHTML = "Read More";
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("justify-content","start","important");
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("height","90%","important");
  }
  if (storeSlidePosition == etcStoreSlider.getElementsByTagName('p').length - 1){
    storeSlidePosition = 0;
    slideStoreIn();
  }else{
    storeSlidePosition = storeSlidePosition + 1;
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].classList.add('inWindow');
    if (etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].classList.contains('overflowReview')){
      etcOverflowExpand.style.display = "block";
    }else{
      etcOverflowExpand.style.display = "none";
    }
    storeT = setTimeout(function(){slideStoreOut();}, 6000);
  }
}



function slideStoreBack(){
  if (expandedContainer) {
    etcStoreReviewContainer.classList.remove('etcContainerExpanded');
    expandedContainer = false;
    etcOverflowExpand.innerHTML = "Read More";
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("justify-content","start","important");
    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].style.setProperty("height","90%","important");
  }
  clearTimeout(storeT);      
  if (storeSlidePosition == 0){
    storeSlidePosition = etcStoreSlider.getElementsByTagName('p').length - 1;
    for (var x = 1;x < etcStoreSlider.getElementsByTagName('p').length;x++){
      etcStoreSlider.getElementsByTagName('p')[x].classList.add('inWindow');
    }
    if (etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].classList.contains('overflowReview')){
      etcOverflowExpand.style.display = "block";
    }else{
      etcOverflowExpand.style.display = "none";
    }
    storeT = setTimeout(function(){slideStoreOut();}, 6000);

  }else{

    storeSlidePosition = storeSlidePosition - 1;

    etcStoreSlider.getElementsByTagName('p')[storeSlidePosition + 1].classList.remove('inWindow');

    if (etcStoreSlider.getElementsByTagName('p')[storeSlidePosition ].classList.contains('overflowReview')){
      etcOverflowExpand.style.display = "block";
    }else{
      etcOverflowExpand.style.display = "none";
    }
    storeT = setTimeout(function(){slideStoreOut();}, 6000);
  }
}

function slideStoreIn(){
  for (var x = etcStoreSlider.getElementsByTagName('p').length - 1;x > 0;x--){
    etcStoreSlider.getElementsByTagName('p')[x].classList.remove('inWindow');
  }
  if (etcStoreSlider.getElementsByTagName('p')[storeSlidePosition].classList.contains('overflowReview')){
    etcOverflowExpand.style.display = "block";
  }else{
    etcOverflowExpand.style.display = "none";
  }
  storeT = setTimeout(function(){slideStoreOut();}, 6000);
}